import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Isvg from 'react-inlinesvg';
import { LINEART_BLUE } from 'constants/icons';
import modal from 'decorators/Modal/Modal';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { isEmpty } from 'helpers/verify';
import { glsLocation, waitlistRequest } from 'redux/saga/entities/bound';
import { selectUserLocation } from 'redux/modules/locale';
import { LocationFormContainer } from './LocationForm';
import { ThankYou } from './ThankYou';
import { WaitlistFormContainer } from './WaitlistForm';
import { watchLocationForm, watchWaitlistForm } from './location.saga';
export var LocationModalUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LocationModalUnwrapped, _PureComponent);

  function LocationModalUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LocationModalUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LocationModalUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isLocationSubmitted: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleLocationSubmit", function () {
      return _this.setState({
        isLocationSubmitted: true
      });
    });

    return _this;
  }

  _createClass(LocationModalUnwrapped, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isPurchasableMsa = _this$props.isPurchasableMsa,
          isLocated = _this$props.isLocated,
          isWaitlisted = _this$props.isWaitlisted;
      var isLocationSubmitted = this.state.isLocationSubmitted;
      var shouldShowWaitlist = isLocated && !isPurchasableMsa;
      return React.createElement("div", {
        className: "modal__body"
      }, React.createElement("div", {
        className: "modal__column"
      }, React.createElement("div", {
        className: "location-modal"
      }, React.createElement(Isvg, {
        key: "location-modal.icon",
        className: "location-modal__icon",
        src: LINEART_BLUE.map_pin
      }), // eslint-disable-next-line no-nested-ternary
      !isLocationSubmitted ? React.createElement(LocationFormContainer, {
        onFormSubmit: this.handleLocationSubmit
      }) : isWaitlisted ? React.createElement(ThankYou, null) : shouldShowWaitlist && React.createElement(WaitlistFormContainer, null))));
    }
  }]);

  return LocationModalUnwrapped;
}(PureComponent);
LocationModalUnwrapped.propTypes = {
  isPurchasableMsa: PropTypes.bool.isRequired,
  isLocated: PropTypes.bool.isRequired,
  isWaitlisted: PropTypes.bool.isRequired
};
export var mapStateToProps = function mapStateToProps(state) {
  var _ref = selectUserLocation(state) || {},
      lat = _ref.lat,
      lon = _ref.lon;

  var userLocation = glsLocation.data(state, "".concat(lat, "_").concat(lon));
  return {
    isLocated: !isEmpty(userLocation),
    isPurchasableMsa: deepExtract('msa.package_purchase', userLocation, false),
    isWaitlisted: !isEmpty(waitlistRequest.data(state))
  };
};
export var Modal = decorateWith(modal({
  modalContentClass: 'modal__content--location-modal'
}), connect(mapStateToProps), withSagas({
  watch: [watchLocationForm, watchWaitlistForm]
}))(LocationModalUnwrapped);